const cacswiper = new Swiper('.cac-agenda-swiper', {
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 1,
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 2,
      spaceBetween: 20
    }
  },

  // Navigation arrows
  navigation: {
    nextEl: '.cac-agenda-btn-right',
    prevEl: '.cac-agenda-btn-left',
  }
});

const cacMinutesSwiper = new Swiper('.cac-minutes-swiper', {
  breakpoints: {
    640: {
      slidesPerView: 1,
      grid: {
        rows: 1,
        fill: 'column'
      },
    },
    768: {
      slidesPerView: 1,
      grid: {
        rows: 1,
        fill: 'row'
      },
    },
    1024: {
      slidesPerView: 2,
      grid: {
        rows: 2,
        fill: 'row'
      },
    },
  },
  spaceBetween: 20,
  navigation: {
    nextEl: '.cac-minutes-btn-right',
    prevEl: '.cac-minutes-btn-left',
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".content-section"); // divs with ids
  const navLinks = document.querySelectorAll(".mats-side-nav a");

  function setActiveLink(id) {
    navLinks.forEach(link => {
      link.classList.remove("active");
      if (link.getAttribute("href") === "#" + id) {
        link.classList.add("active");
      }
    });
  }

  function onScroll() {
    let currentSectionId = "";

    sections.forEach(section => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      const scrollY = window.scrollY;

      if (scrollY >= sectionTop - 50 && scrollY < sectionTop + sectionHeight - 50) {
        currentSectionId = section.getAttribute("id");
      }
    });

    if (currentSectionId) {
      setActiveLink(currentSectionId);
    }
  }

  // Set default active link on page load
  setActiveLink("aboutpc");

  // Attach scroll listener
  window.addEventListener("scroll", onScroll);
});

jQuery(function ($) {
  // --- Helper to detect YouTube URLs ---
  function isYouTube(url){
    if (!url) return false;
    try {
      var u = new URL(url, window.location.origin);
      var h = u.hostname.toLowerCase();
      return h.includes('youtube.com') || h.includes('youtu.be');
    } catch(e){ return false; }
  }

  // Initialize Video.js once
  var player = (videojs.getPlayer && videojs.getPlayer('main-video')) || videojs('main-video', { fluid: true });

  // Loader (no autoplay)
  window.loadVideo = function (src, poster) {
    if (!src) return;
    player.pause();
    player.src({ type: 'video/mp4', src: src });
    if (poster) player.poster(poster);
    player.load(); // preload only
  };

  $('.video-btn-list[data-group]').each(function () {
    var $root = $(this);
    var $year = $root.find('.mats-video-year');
    var $list = $root.find('.mats-video-list');

    var group = String($root.data('group') || 'cac');
    var postId = $root.data('post') || '';
    var fullRange = String($root.data('fullRange') || $root.data('full-range')) === '1';

    var rest = (window.MATS_VIDEOS && window.MATS_VIDEOS.rest)
      ? window.MATS_VIDEOS.rest
      : ((window.wpApiSettings && window.wpApiSettings.root)
        ? (window.wpApiSettings.root + 'mats/v1/videos')
        : '/wp-json/mats/v1/videos');

    function fetchVideos(year) {
      var params = { group: group };
      if (postId) params.post_id = postId;
      if (year) params.year = year;
      return $.getJSON(rest, params);
    }

    function renderYears(years) {
      $year.empty();
      $.each(years, function (i, y) {
        $('<option/>', { value: y, text: y, selected: i === 0 }).appendTo($year);
      });
      $year.closest('.mb-3')[(years.length ? 'show' : 'hide')]();
    }

    function fullRangeYears() {
      var now = (new Date()).getFullYear();
      var yrs = [];
      for (var y = 2000; y <= now + 1; y++) yrs.push(y);
      return yrs.reverse();
    }

    function renderList(items) {
      $list.empty();
      if (!items || !items.length) {
        $list.append('<li><em>No videos for this year.</em></li>');
        return;
      }
      $.each(items, function (_, item) {
        var url = item.url || '';
        var external = isYouTube(url); // true for YouTube
        var icon = external ? 'fa-arrow-up-right-from-square' : 'fa-circle-play';
        var label = (item.label || 'Untitled') + (external ? ' (YouTube)' : '');

        var $li = $('<li/>');
        var $btn = $('<button/>', {
          type: 'button',
          'class': 'btn btn-primary w-100 text-start mb-2',
          'data-src': url,
          'data-poster': item.poster || '',
          'data-external': external ? '1' : '0',
          html: '<i class="fa-solid ' + icon + ' me-2"></i>' + label,
          'aria-label': external ? 'Open on YouTube: ' + (item.label || 'video') : 'Play video: ' + (item.label || 'video')
        });
        $li.append($btn).appendTo($list);
      });
      $list.append('<li><a href="https://www.youtube.com/watch?v=reYQKHVXcj0" class="btn btn-primary w-100 text-start mb-2"><i class="fa-solid fa-circle-play me-2"></i> May 5, 2025</a></li>');
    }

    function setActive($btn) {
      $list.find('button').removeClass('active');
      if ($btn && $btn.length) $btn.addClass('active');
    }

    function loadFromFirst() {
      // Prefer the first non-external (MP4) item for initial load
      var $btn = $list.find('button[data-src][data-external="0"]').first();
      if ($btn.length) {
        setActive($btn);
        window.loadVideo($btn.data('src'), $btn.data('poster'));
      }
      // If all items are YouTube, do nothing until user clicks.
    }

    // INIT
    fetchVideos().done(function (data) {
      var allItems = (data && $.isArray(data.items)) ? data.items : [];
      var years = fullRange ? fullRangeYears() : ((data && $.isArray(data.years)) ? data.years : []);

      if (!years.length && allItems.length) {
        var map = {};
        $.each(allItems, function (_, it) { if (it.year != null) map[it.year] = true; });
        years = Object.keys(map).sort(function (a, b) { return b - a; });
      }

      if (years.length) {
        renderYears(years);
        var selectedYear = String(years[0]);
        var itemsForYear = $.grep(allItems, function (i) { return String(i.year) === selectedYear; });
        renderList(itemsForYear.length ? itemsForYear : allItems);
      } else {
        renderList(allItems);
      }

      loadFromFirst();
    }).fail(function () {
      $list.html('<li><em>Unable to load videos.</em></li>');
    });

    // Events
    $root.on('change', '.mats-video-year', function () {
      var y = $(this).val();
      fetchVideos(y).done(function (d) {
        var items = (d && $.isArray(d.items)) ? d.items : [];
        renderList(items);
        loadFromFirst();
      }).fail(function () {
        $list.html('<li><em>Unable to load videos.</em></li>');
      });
    });

    $root.on('click', 'button[data-src]', function () {
      var $btn = $(this);
      var external = String($btn.data('external')) === '1';
      var url = $btn.data('src') || '';

      if (external && url) {
        // Open YouTube in new tab
        window.open(url, '_blank', 'noopener');
        return;
      }

      setActive($btn);
      window.loadVideo(url, $btn.data('poster'));
    });
  });
});
